import styled from "styled-components";
import Button from "../Button";

export const Container = styled.article`
  text-align: center;
  width: 300px;
  .error {
    transform: translateY(-5px);
    font-size: 1rem;
    color: red;
  }
`;

export const BottonStyle = styled(Button)`
  width: 280px;
`;
